import {useFormik} from 'formik';
import {useState} from 'react';
import {useFundraiserStoryById} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';
import {dateTimeParse} from '@gravity-ui/date-utils';
import {DateTime} from '@gravity-ui/date-utils';

type UseEditAppealStoryFormProps = {
  appealId: string;
  storyId: string | null;
  setOpen: (open: boolean) => void;
};

export const useEditAppealStoryForm = ({appealId, storyId, setOpen}: UseEditAppealStoryFormProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {updateStoryMutation, getStory} = useFundraiserStoryById(appealId, storyId || '');
  const {data: story} = getStory;

  const onSubmit = async (values: {title: string; priority: number; date: DateTime | null}) => {
    if (!storyId || !values.date) return;

    setErrorMessage(null);
    try {
      await updateStoryMutation.mutateAsync({
        title: values.title,
        priority: values.priority,
        date: values.date.format('YYYY-MM-DD'),
      });
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при обновлении истории сбора');
    }
  };

  const handleDateChange = (date: DateTime | null) => {
    formik.setFieldValue('date', date);
  };

  const formik = useFormik({
    initialValues: {
      title: story?.title || '',
      priority: story?.priority || 0,
      date: (story?.date ? dateTimeParse(story.date) : null) as DateTime | null,
    },
    validationSchema: Yup.object({
      title: Yup.string().max(256, 'Заголовок не должен превышать 256 символов').required('Заголовок обязателен'),
      priority: Yup.number().required('Приоритет обязателен'),
      date: Yup.mixed().required('Дата обязательна'),
    }),
    onSubmit,
    enableReinitialize: true,
  });

  return {
    ...formik,
    handleDateChange,
    isLoading: updateStoryMutation.isPending,
    submitError: updateStoryMutation.error
      ? (updateStoryMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    errorMessage,
    submitForm: () => formik.handleSubmit(),
  };
};
